import { LogsGenerator } from './LogsGenerator.main';

export { LogsGenerator };
